import * as React from "react";
import { observer } from "mobx-react-lite";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderLambdalabsUnmanagedNodePoolAddRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (isDone) {
      navigate(
        `${pathname.replace("-add", "")}${
          mk8sDraft.provider_lambdalabs.unmanagedNodePools[mk8sDraft.provider_lambdalabs.unmanagedNodePools.length - 1]
            .index
        }`,
      );
      return;
    }

    mk8sDraft.provider_lambdalabs.addUnmanagedNodePool();
    setIsDone(true);
  }, [isDone]);

  return null;
};

export const ProviderLambdalabsUnmanagedNodePoolAdd = observer(ProviderLambdalabsUnmanagedNodePoolAddRaw);
